<script setup lang="ts">
import type { Component } from 'vue';
import type { AnyItem, DisplayTemplateAst, GlobalCollectionId } from '#layers/data-model/public';
import { isEmptyDisplayTemplate } from '#layers/data-model/public';

interface CalendarEvent {
	id: string | number;
	title?: string;
}

defineProps<{
	calendarEvent: CalendarEvent;
	item: AnyItem | undefined;
	titleTemplate: DisplayTemplateAst | null;
	collectionId: GlobalCollectionId;
	renderDisplayTemplate: Component;
}>();
</script>

<!--
	Schedule-X strips an event's default background, padding and border whenever a custom event
	slot is supplied, expecting the slot to own its appearance. We recreate the box here as a soft
	primary badge using semantic color tokens.
-->
<template>
	<div
		data-calendar-event
		class="
			flex size-full items-center overflow-hidden rounded-sm border-s-4 border-s-primary bg-primary/10 p-1 text-xs
			whitespace-nowrap text-primary
		"
	>
		<component
			:is="renderDisplayTemplate"
			v-if="item && !isEmptyDisplayTemplate(titleTemplate)"
			:item
			:display-template="titleTemplate"
			:collection-id
			:root="false"
		/>
		<template v-else>
			{{ calendarEvent.title }}
		</template>
	</div>
</template>
